import api from "APP_ROOT/api";

export function searchAircrafts(filter) {
  return api.aircrafts
    .search({
      filter,
      page: 1,
      limit: 15
    })
    .then(({ data }) => Promise.resolve(data.results));
}



// WEBPACK FOOTER //
// ./app/modules/Aircraft/actions.js